import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

type CoachingProps = {
  className?: string
  children: React.ReactNode
}

function TipComponent({ children, className }: CoachingProps) {
  return (
    <div className={className}>
      <plume.glyphs.stroke.Bulb size={10} />
      <plume.styles.copy.S.regular>{children}</plume.styles.copy.S.regular>
    </div>
  )
}

export const Tip = styled(TipComponent)`
  background-color: ${plume.COLORS.PRIMARY_GREY_000};
  bottom: calc(50px + 16px + 16px);
  display: flex;
  margin: 10px 0;

  bottom: 82px;
  display: flex;
  margin: 10px 0px;
  position: sticky;
  z-index: 2;
  padding: 16px 0 0;

  ${plume.glyphs.stroke.Bulb} {
    background-color: ${plume.COLORS.SECONDARY_GREEN_500};
    color: ${plume.COLORS.PRIMARY_GREY_000};
    border-radius: 50%;
    width: 10px;
    height: 14px;
    padding: 4px 6px;
    margin-right: 14px;
    flex: 0 0 auto;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    bottom: unset;
    margin: 60px 0 16px;
    position: unset;
    width: calc(100% - 250px);
  }
`
